import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-header-tooltip',
  templateUrl: './table-header-tooltip.component.html',
  styleUrls: ['./table-header-tooltip.component.scss']
})
export class TableHeaderTooltipComponent implements OnInit {
  @Input() toolTipTemplate: any;
  @Input() data: any;
  @Input() key: string;
  constructor() { }

  ngOnInit(): void {
  }

}
